export default {
  id: 23,
  pride: 20480,
  slug: "abnormal-emotion-self-check",
  category: "tool",
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "异常情绪自检SOP",
    en: "Abnormal Emotion Self-Check SOP"
  },
  image: require('@/assets/images/MoodCheckSOP.webp'),
  descriptionKey: {
    zh: "一个异常情绪自检工具。",
    en: "An abnormal emotion self-check tool."
  },
  date: { year: 2025, month: 4 },
  genres: ["心理工具", "自检"],
  themes: ["情绪管理", "心理健康"],
  engine: "Web",
  platform: ["Web"],
  tags: ["自用工具"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "web", url: "https://mood.tobenot.top/", textKey: { zh: "在线使用", en: "Use Online" } }
  ]
};
